import React from 'react';
import { AssessmentState } from '../types';
import { s1KelasA, s1KelasB, s2 } from '../data/students';
import { ChevronDown } from 'lucide-react';
interface ProductSelectorProps {
  state: AssessmentState;
  onChange: (updates: Partial<AssessmentState>) => void;
}
export function ProductSelector({
  state,
  onChange
}: ProductSelectorProps) {
  const getStudentsList = () => {
    if (state.jenjang === 'S1') {
      if (state.kelas === 'A') return s1KelasA;
      if (state.kelas === 'B') return s1KelasB;
      return [];
    }
    if (state.jenjang === 'S2') return s2;
    return [];
  };
  const students = getStudentsList();
  return <div className="space-y-6" data-id="element-42">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-43">
        {/* Jenjang */}
        <div className="space-y-2" data-id="element-44">
          <label className="block text-sm font-medium text-[#1d1d1f]/70" data-id="element-45">
            Jenjang
          </label>
          <div className="relative" data-id="element-46">
            <select value={state.jenjang} onChange={e => onChange({
            jenjang: e.target.value as any,
            kelas: '',
            student: ''
          })} className="w-full appearance-none bg-white border border-[#d2d2d7] rounded-xl py-3 pl-4 pr-10 text-[15px] text-[#1d1d1f] focus:outline-none focus:ring-2 focus:ring-[#0071e3]/30 focus:border-[#0071e3] transition-all apple-shadow-sm" data-id="element-47">
              <option value="" data-id="element-48">Pilih Jenjang</option>
              <option value="S1" data-id="element-49">S1</option>
              <option value="S2" data-id="element-50">S2</option>
            </select>
            <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#86868b] pointer-events-none" data-id="element-51" />
          </div>
        </div>

        {/* Kelas (Only for S1) */}
        {state.jenjang === 'S1' && <div className="space-y-2" data-id="element-52">
            <label className="block text-sm font-medium text-[#1d1d1f]/70" data-id="element-53">
              Kelas
            </label>
            <div className="relative" data-id="element-54">
              <select value={state.kelas} onChange={e => onChange({
            kelas: e.target.value as any,
            student: ''
          })} className="w-full appearance-none bg-white border border-[#d2d2d7] rounded-xl py-3 pl-4 pr-10 text-[15px] text-[#1d1d1f] focus:outline-none focus:ring-2 focus:ring-[#0071e3]/30 focus:border-[#0071e3] transition-all apple-shadow-sm" data-id="element-55">
                <option value="" data-id="element-56">Pilih Kelas</option>
                <option value="A" data-id="element-57">Kelas A</option>
                <option value="B" data-id="element-58">Kelas B</option>
              </select>
              <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#86868b] pointer-events-none" data-id="element-59" />
            </div>
          </div>}
      </div>

      {/* Student Selection */}
      {(state.jenjang === 'S1' && state.kelas || state.jenjang === 'S2') && <div className="space-y-2 animate-in fade-in slide-in-from-top-2 duration-300" data-id="element-60">
          <label className="block text-sm font-medium text-[#1d1d1f]/70" data-id="element-61">
            Nama Mahasiswa (Produk Milik)
          </label>
          <div className="relative" data-id="element-62">
            <select value={state.student} onChange={e => onChange({
          student: e.target.value
        })} className="w-full appearance-none bg-white border border-[#d2d2d7] rounded-xl py-3 pl-4 pr-10 text-[15px] text-[#1d1d1f] focus:outline-none focus:ring-2 focus:ring-[#0071e3]/30 focus:border-[#0071e3] transition-all apple-shadow-sm" data-id="element-63">
              <option value="" data-id="element-64">Pilih Mahasiswa</option>
              {students.map(s => <option key={s.nim} value={`${s.nim} — ${s.name}`} data-id="element-65">
                  {s.nim} — {s.name}
                </option>)}
            </select>
            <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#86868b] pointer-events-none" data-id="element-66" />
          </div>
        </div>}
    </div>;
}